import './images/hero.png';
import './index.scss';
import { MediaQuery } from 'utils/media_query';
import { fetchJanusOabRedirectUrl } from 'utils/janus_oab_redirect';

const NAV_CTA_SELECTOR = '.js-oab-damasio-nav-cta';
const MOBILE_NAV_CTA_ID = 'js-oab-damasio-mobile-nav-cta';
const MODAL_CTA_SELECTOR = '#cta-oab-damasio-sso';
const MODAL_SELECTOR = '#js-oab-damasio-modal';
const MODAL_WITHOUT_HERO_CLASS = 'js-oab-damasio-modal--without-hero';

function setModalHeroVisibility(fromMobileMenu) {
  $(MODAL_SELECTOR).toggleClass(MODAL_WITHOUT_HERO_CLASS, fromMobileMenu);
}

function closeMobileMenu() {
  if (MediaQuery.is('lt_header_lg_breakpoint')) {
    $('#segments-toggle-input').prop('checked', false);
    $('body').removeClass('q-no-scroll q-mobile-menu-open');
  }
}

function navCtaClickSource(target) {
  return target.id === MOBILE_NAV_CTA_ID ? 'navbar mobile menu' : 'navbar';
}

function armCta($cta) {
  $cta.data('redirecting', true);
  $cta.prop('disabled', true);
  $cta.attr('aria-busy', 'true');
}

function releaseCta($cta) {
  $cta.data('redirecting', false);
  $cta.prop('disabled', false);
  $cta.removeAttr('aria-busy');
}

// Analytics must never block a redirect: a missing or broken tracker only gets
// reported, the caller carries on.
function emitEvent(eventName, data) {
  try {
    window.UserTracker.emit('event', { eventName, data });
  } catch (trackerErr) {
    Rollbar.error(`Erro ao emitir evento ${eventName}`, trackerErr);
  }
}

async function redirectToJanusOab($cta, clickSource) {
  // Minting an SSO token + emitting analytics + navigating is not idempotent,
  // and the awaited fetch leaves a window where a second click would fire it
  // all again. Ignore re-clicks while a redirect is already in flight.
  if ($cta.data('redirecting')) {
    return;
  }
  armCta($cta);

  try {
    const sourceUrl = window.location.href;

    emitEvent('damasio redirect clicked', {
      'click source': clickSource,
      'source url': sourceUrl
    });

    const redirectUrl = await fetchJanusOabRedirectUrl(null, null, sourceUrl);
    window.location.href = redirectUrl;
  } catch (err) {
    // Defensive guard: fetchJanusOabRedirectUrl never rejects (it swallows
    // failures and resolves with its fallback URL), so this catch only fires
    // on unexpected errors in this handler itself (e.g. Rollbar missing in
    // the analytics catch above).
    //
    // Release the guard only on failure so the button recovers. After the
    // `location.href` assignment the page stays alive until the cross-origin
    // navigation completes, so on success the guard must stay set to keep
    // swallowing re-clicks (no double token mint / duplicate analytics).
    releaseCta($cta);
    Rollbar.error('Erro ao redirecionar para Janus OAB', err);
  }
}

$(document).on('click', NAV_CTA_SELECTOR, function (e) {
  e.preventDefault();

  const clickSource = navCtaClickSource(e.currentTarget);
  const $modal = $(MODAL_SELECTOR);

  emitEvent('oab damasio nav cta clicked', { 'click source': clickSource });

  // The CTA lives in the shared Header, which more layouts render than the ones
  // rendering this modal. jQuery no-ops on an empty set, so without this guard
  // the button would silently do nothing on such a layout. The modal is an
  // upsell surface, not a hard dependency: send the user straight to Damásio
  // and report the misconfigured layout instead of dead-ending the click.
  if ($modal.length === 0) {
    Rollbar.error(
      'Modal OAB Damásio ausente no layout; redirecionando direto',
      { 'click source': clickSource }
    );
    redirectToJanusOab($(e.currentTarget), clickSource);
    return;
  }

  closeMobileMenu();
  setModalHeroVisibility(e.currentTarget.id === MOBILE_NAV_CTA_ID);
  $modal.modal('show');
});

// Delegated handler: the modal markup is rendered by the layout, so we bind
// on `document` rather than the (possibly not-yet-present) button itself.
$(document).on('click', MODAL_CTA_SELECTOR, function (e) {
  e.preventDefault();

  redirectToJanusOab($(this), 'navbar oab damasio modal');
});
